<template>
    <div class="global-card__grid global-card-grid--three-cards justify-content-center">
      <div class="global-card p-0 gap-0" v-for="(note, index) in notes"
        :key="note._id"
        :class="index === 0 ? 'min-width-note' : ''"
        :style="index !== 0 ? 'min-width:400px;' : ''">

        <img :src="url(note, index === 0 ? 'banner' : 'thumbnail')"
          :alt="notes.name"
          :class="index === 0 ? 'main-image' : 'image-for-regular-note'"
          v-if="url(note, index === 0 ? 'banner' : 'thumbnail')"/>

        <div class="p-4">
          <h2 class="blog-title h2-zensavvy">{{ note.name }}</h2>
          <p class="blog-excerpt">{{ note.blurb }}</p>
        </div>
        <a :href=" `/${locale}/blog/${note.slug}`" class="read-more">{{ translations.read_more_button }}</a>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    inject: ['translations', 'locale'],

    props: {
      notes: {
        type: Array,
        required: true,
      },
    },
    
    methods: {
        url(note, imageAttribute) {
            if (note[imageAttribute] == null) { return null }
            else if (typeof note[imageAttribute] === 'object') { return note[imageAttribute].url }
            else if (typeof note[imageAttribute] === 'string') { return note[imageAttribute] }
            return ''
        }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .min-width-note{ 
    min-width: 90% !important;

    @media (max-width: 924px) {
      min-width: 400px !important;
      img {
        width: 100% !important;
        height:auto !important;
        filter: none !important;
        aspect-ratio:16/10;
        object-fit: cover !important;
      }
    }
  }

  .main-image {
    width: 100% !important;
    height: 100% !important;
    filter: none !important;
  }

  .image-for-regular-note {
    width: 100% !important;
    height:auto !important;
    filter: none !important;
    aspect-ratio:16/10;
    object-fit: cover !important;
  }

  .blog-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    gap: 20px;
    padding: 20px;
  }
  
  .blog-card {
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .blog-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  }
  
  .blog-image img {
    width: 100%;
    height: 200px;
    object-fit: cover;
  }
  
  .blog-content {
    padding: 20px;
  }
  
  .blog-title {
    font-size: 24px;
    margin: 0;
    font-weight: bold;
  }
  
  .blog-excerpt {
    margin: 10px 0;
    font-size: 16px;
    color: #666;
  }
  
  .read-more {
    display: inline-block;
    margin-top: 10px;
    font-size: 14px;
    color: #007BFF;
    text-decoration: none;
    transition: color 0.3s ease;
  }
  
  .read-more:hover {
    color: #0056b3;
  }
  </style>
  